import { render, staticRenderFns } from "./ContestSwornShowComponent.vue?vue&type=template&id=58af35e0"
import script from "./ContestSwornShowComponent.vue?vue&type=script&lang=js"
export * from "./ContestSwornShowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports